import { getOffersMock } from '@amp/bff/staff/index.msw';

export const staffHandlers = [...getOffersMock()];
